<template>
    <div id="app">
        <div>
            <SignInPCB v-if="isPC" />
            <SignInH5B v-else />
        </div>
    </div>
</template>
<script>
import { enableAppShare } from '../../../common/js/APP/share';
import SignInPCB from '../components/SignInPCBNew';
import SignInH5B from '../components/SignInH5BNew';
import loadScript from '../../../uitl/load-script';
export default {
    components: {
        SignInH5B,
        SignInPCB
    },
    data() {
      return {
        isBView:'',//A版      B版
        canvasUrl: 'https://static.lagou.com/wx-mina/static/asset/common/share_java_a4da1f9.png'
      };
    },
    mounted() {
      loadScript('https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
      enableAppShare({
        title: '成为阿里P7真的那么难么？',
        desc: 'Java工程师注意啦！实战技术干货+拉勾硬核直推，名额不多，先到先得！',
        imgUrl: this.canvasUrl,
      });
      // this.getPageFn()
    },
    methods: {
      // getPageFn() {
      //   let json_param = JSON.parse(getCookie('JAVA_ARCHITECT')) || {pageVersion: null, pageType: null}
      //   let params = {
      //     pageContext: "JAVA_ARCHITECT",
      //     pageVersion: json_param.pageVersion,
      //     pageType: json_param.pageType,

      //   }
      //   fetchQueryFN(params).then(res => {
      //     if(res.state == 1) {
      //         if(res.content.hitType == 1) { //命中页面 不返回值
      //             let json_param = JSON.parse(getCookie('JAVA_ARCHITECT')) || {pageVersion: null, pageType: null}
      //             this.isBView = json_param && json_param.pageType == 2 ? 'B' : 'A';
      //         } else if (res.content.hitType == 2) { //刷新页面
      //             this.isBView = res.content && res.content.pageType == 2 ? 'B' : 'A';
      //             let json_param = {
      //                 pageVersion: res.content.pageVersion,
      //                 pageType: res.content.pageType
      //             }
      //             setCookie('JAVA_ARCHITECT', JSON.stringify(json_param))
      //         } else { //未命中 走a版
      //             this.isBView = 'A'
      //         }
      //     } else {
      //         this.isBView = 'A'  //默认a版  报错a版
      //     }
      //   }).catch(error => {
      //       this.isBView = 'A'  //默认a版  报错a版
      //   });
      // },
    },
};
</script>
<style>
 body {
        -webkit-overflow-scrolling: touch;
    }
  #app {
    height: 100%;
    overflow-x: hidden;
  }

  #appHeader {
    position: fixed;
    width: 100%;
    z-index: 10;
    left: 0;
    top: 0;
  }

  .single-line {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .lg_tbar_r {
    font-size: 14PX;
  }

  .scale-1px {
    position: relative;
    border: none;
  }

  .scale-1px:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #000;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }

  .clearfix:after {
    content: '';
    height: 0;
    display: block;
    clear: both;
  }
</style>
